import React, { Component } from 'react';
import { Input, Button, Confirm, Modal, Popup, Progress, Transition, Dropdown, Grid, Segment } from 'semantic-ui-react'
import axios from 'axios'
import { AutoSizer, Column, Table } from 'react-virtualized'
import 'react-virtualized/styles.css';
import './testStyles.css'

const headerStyle = {
  textTransform: 'none'
}
const defaultRowStyle = {
  background: 'white',
  borderBottom: '1px solid #4c4c4c'
}

class finalTest extends Component {
  constructor(props) {
    super(props);
    this.state = {
      finalTestState: [],
      finalTestAnswers: [],
      openConfirmBox: false,
      incorrectEntries: [0, 0, 0, 0],
      submitRow: 0,
      progressBarInd: 0,
      progressBarTot: 1,
      itemError: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      wholesaleError: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      asinError: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      passInd: [false, false, false, false, false, false, false, false, false, false, 
        false, false, false, false, false, false, false, false, false, false,
        false, false, false, false, false, false, false, false, false, false,
        false, false, false, false, false, false, false, false, false, false,
        false, false, false, false, false, false, false, false, false, false,
        false, false, false, false, false, false, false, false, false, false,
        false, false, false, false, false, false, false, false, false, false,
        false, false, false, false, false, false, false, false, false, false,
        false, false, false, false, false, false, false, false, false, false,
        false, false, false, false, false, false, false, false, false, false],
      popUpOpenInd: [false, false, false, false, false, false, false, false, false, false, 
        false, false, false, false, false, false, false, false, false, false,
        false, false, false, false, false, false, false, false, false, false,
        false, false, false, false, false, false, false, false, false, false,
        false, false, false, false, false, false, false, false, false, false,
        false, false, false, false, false, false, false, false, false, false,
        false, false, false, false, false, false, false, false, false, false,
        false, false, false, false, false, false, false, false, false, false,
        false, false, false, false, false, false, false, false, false, false,
        false, false, false, false, false, false, false, false, false, false],
      testTotalCount: [-1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 
        -1, -1, -1, -1, -1, -1, -1, -1, -1, -1,
        -1, -1, -1, -1, -1, -1, -1, -1, -1, -1,
        -1, -1, -1, -1, -1, -1, -1, -1, -1, -1,
        -1, -1, -1, -1, -1, -1, -1, -1, -1, -1,
        -1, -1, -1, -1, -1, -1, -1, -1, -1, -1,
        -1, -1, -1, -1, -1, -1, -1, -1, -1, -1,
        -1, -1, -1, -1, -1, -1, -1, -1, -1, -1,
        -1, -1, -1, -1, -1, -1, -1, -1, -1, -1,
        -1, -1, -1, -1, -1, -1, -1, -1, -1, -1]
    }

    this.submitRowAnswers = this.submitRowAnswers.bind(this)
  }

  async componentWillMount() {
    var self = this;
    //console.log("MOUNTING")
    await axios.get('/api/testInfo', {
      params: {
        testNumber: 7
      }
    })
    .then(function (res, err) {
      self.setState({finalTestState: res.data})
    })

    await axios.get('/api/finalTestRetrieveAnswers', {
    params: {
      testNumber: 7
    }
    })
    .then(function (res, err) {
      self.setState({finalTestAnswers: res.data})
    })

    let tempUserId = this.props.getCookie("loggedInId")
    const {itemError, wholesaleError, asinError, passInd, incorrectEntries} = this.state
    var fullInputAnswersForTest

    await axios.get('/api/queryFullTestAnswers', {
      params: {
        User_Id: tempUserId,
        CorrectAnswerIds: [35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126, 127, 128, 129, 130, 131, 132, 133, 134, 135, 136, 137]
      }
    })
    .then(function (res, err) {
      fullInputAnswersForTest = res.data
    })

    var finalTestState = this.state.finalTestState
    this.setState({progressBarTot: fullInputAnswersForTest.length})

    for (let i = 0; i < fullInputAnswersForTest.length; i++) {
      let currentAnswer = fullInputAnswersForTest[i]
      var rowResults
      var shouldQuery = false

      if (i + 1 < fullInputAnswersForTest.length) {
        if (fullInputAnswersForTest[i + 1].CorrectAnswers_Id !== currentAnswer.CorrectAnswers_Id) {
          shouldQuery = true
        } else {rowResults = "skip"; shouldQuery = false;}
      } else {
        shouldQuery = true
      }

      if (shouldQuery) {
        await axios.get('/api/testCheckAnswers', {
          params: {
            Title: finalTestState[currentAnswer.CorrectAnswers_Id - 35].Title,
            ItemIdentifier: currentAnswer.ItemIdentifier,
            WholesalePrice: currentAnswer.WholesalePrice,
            ItemsPerAsin: currentAnswer.ItemsPerAsin,
            Status: currentAnswer.Status,
            testNumber: 7
          }
        })
        .then(function(res, err) {
          rowResults = res.data
        })
      }

      if (rowResults !== "skip") {
        let AnswerId = currentAnswer.CorrectAnswers_Id - 35

        itemError[AnswerId] = !rowResults.ItemIdentifier
        wholesaleError[AnswerId] = !rowResults.WholesalePrice
        asinError[AnswerId] = !rowResults.ItemsPerAsin

        if (currentAnswer.Pass_Ind) {
          passInd[AnswerId] = true
        }
        //console.log(itemError, wholesaleError, asinError)
        this.setState({itemError: itemError, wholesaleError: wholesaleError, asinError: asinError, passInd: passInd, progressBarInd: i})
        if (itemError[AnswerId]) {
          incorrectEntries[0] = incorrectEntries[0] + 1;
        } else {this.props.incrementFinalTest(0)}
        if (wholesaleError[AnswerId]) {
          incorrectEntries[1] = incorrectEntries[1] + 1;
        } else {this.props.incrementFinalTest(1)}
        if (asinError[AnswerId]) {
          incorrectEntries[2] = incorrectEntries[2] + 1;
        } else {this.props.incrementFinalTest(2)}
        incorrectEntries[3] = incorrectEntries[3] + 1;

        finalTestState[AnswerId].Status = currentAnswer.Status
        finalTestState[AnswerId].itemidentifier = currentAnswer.ItemIdentifier
        finalTestState[AnswerId].manufacturerdesc = currentAnswer.ManufacturerDescription
        finalTestState[AnswerId].wholesale = currentAnswer.WholesalePrice
        finalTestState[AnswerId].itemsperasin = currentAnswer.ItemsPerAsin
        finalTestState[AnswerId].notes = currentAnswer.Notes
      }
    }

    let progressBarTot = this.state.progressBarTot
    this.setState({finalTestState: finalTestState, progressBarInd: progressBarTot + 1, incorrectEntries: incorrectEntries})
    this.props.changeLoadedTest(7)

    //setTimeout(function(){ alert("Hello"); }, 3000);
  }

  handleChange = (e, { id, value }) => {
    var num = id.substring(id.length - 1)
    if (id.substring(id.length - 2) > 9) {
      num = id.substring(id.length - 2)
    } else if (id.substring(id.length - 3) > 99) {
      num = id.substring(id.length - 3)
    }

    let array = this.state.finalTestState
    const objKey = id.substring(0, id.length - num.length);
    array[num][objKey] = value
    this.setState({ finalTestState: array })
  }

  openPopUp = (e) => {
    var num = e.target.id.substring(e.target.id.length - 1)
    if (e.target.id.substring(e.target.id.length - 2) > 9) {
      num = e.target.id.substring(e.target.id.length - 2)
    } else if (e.target.id.substring(e.target.id.length - 3) > 99) {
      num = e.target.id.substring(e.target.id.length - 3)
    }

    var {popUpOpenInd, itemError, wholesaleError, asinError} = this.state
    if (itemError[num] === 0 || wholesaleError[num] === 0 || asinError[num] === 0) {
      popUpOpenInd[num] = true
    } else {popUpOpenInd[num] = false}

    this.setState({popUpOpenInd: popUpOpenInd})
  }

  handleCancel = () => this.setState({ openConfirmBox: false })

  openConfirm = (e, {...props}) => this.setState({ openConfirmBox: true, submitRow: {...props}.id })

  handleChangeStatus = (e, {id, value}) => {
    var num = id.substring(id.length - 1)
    if (id.substring(id.length - 2) > 9) {
      num = id.substring(id.length - 2)
    } else if (id.substring(id.length - 3) > 99) {
      num = id.substring(id.length - 3)
    }

    var array = this.state.finalTestState
    var popUpArray = this.state.popUpOpenInd
    const objKey = id.substring(0, id.length - num.length);
    array[num][objKey] = value
    popUpArray[num] = false
    this.setState({ finalTestState: array, popUpOpenInd: popUpArray })
  }

  async submitRowAnswers() {
    var self = this;
    self.setState({ openConfirmBox: false })
    //console.log(this.state.finalTestState[this.state.submitRow])
    //First need to verify that all answers are filled out
    var answers = self.state.finalTestState[self.state.submitRow]
    var itemError = self.state.itemError
    var wholesaleError = self.state.wholesaleError
    var asinError = self.state.asinError
    var passInd = self.state.passInd
    var testTotalCount = self.state.testTotalCount
    var incorrectEntries = self.state.incorrectEntries

    if (answers.itemidentifier === undefined) { answers.itemidentifier = "" };
    if (answers.wholesale === undefined) { answers.wholesale = "" };
    if (answers.itemsperasin === undefined) { answers.itemsperasin = "" };
    if (answers.manufacturerdesc === undefined) { answers.manufacturerdesc = "" };
    if (answers.notes === undefined) { answers.notes = "" };
    if (answers.Status === undefined) { answers.Status = "Go" };

    var tempUsername = this.props.getCookie("loggedInId")

    var didPass = 0
    var answerId = 0

    await axios.get('/api/testCheckAnswers', {
      params: {
        Title: answers.Title,
        ItemIdentifier: answers.itemidentifier,
        WholesalePrice: answers.wholesale,
        ItemsPerAsin: answers.itemsperasin,
        Status: answers.Status,
        testNumber: 7
      }
    })
    .then(function (res, err) {
      //console.log(res.data)

      itemError[self.state.submitRow] = !res.data.ItemIdentifier
      wholesaleError[self.state.submitRow] = !res.data.WholesalePrice
      asinError[self.state.submitRow] = !res.data.ItemsPerAsin
      answerId = res.data.answerId
      if (res.data.ItemIdentifier === true && res.data.WholesalePrice === true && res.data.ItemsPerAsin === true) {
        didPass = 1
        passInd[self.state.submitRow] = true
      }
      //console.log(itemError, wholesaleError, asinError)
      if (itemError[self.state.submitRow]) {
        incorrectEntries[0] = incorrectEntries[0] + 1;
      } else {self.props.incrementFinalTest(0)}
      if (wholesaleError[self.state.submitRow]) {
        incorrectEntries[1] = incorrectEntries[1] + 1;
      } else {self.props.incrementFinalTest(1)}
      if (asinError[self.state.submitRow]) {
        incorrectEntries[2] = incorrectEntries[2] + 1;
      } else {self.props.incrementFinalTest(2)}
      if (incorrectEntries[0] + incorrectEntries[1] + incorrectEntries[2] > 40) {
        self.props.failedOrPassedFinalTest(false);
      }
      incorrectEntries[3] = incorrectEntries[3] + 1;
      if (incorrectEntries[3] === 103) {
        self.props.failedOrPassedFinalTest(true);
      }
      self.setState({itemError: itemError, wholesaleError: wholesaleError, asinError: asinError, incorrectEntries: incorrectEntries})
      //console.log(answers)
    })

    var curDate = new Date();
    await axios.post('/api/inputAnswers', {
      CorrectAnswers_Id: answerId,
      Status: answers.Status,
      ItemIdentifier: answers.itemidentifier,
      ManufacturerDescription: answers.manufacturerdesc,
      WholesalePrice: answers.wholesale,
      ItemsPerAsin: answers.itemsperasin,
      Notes: answers.notes,
      User_Id: tempUsername,
      Date: curDate,
      Pass_Ind: didPass
    })
    .then(function (res, err) {
      if (err) throw err;
      //console.log(res)
    })

    await axios.get('/api/queryInputAnswers', {
      params: {
        User_Id: tempUsername,
        CorrectAnswers_Id: answerId
      }
    })
    .then(function (res, err) {
      if (err) throw err;
      let entryLength = res.data.length - 1
      for (let i = 0; i < res.data.length; i++) {
        let correctAnswerId = res.data[i].CorrectAnswers_Id - 35
        if (correctAnswerId !== testTotalCount[correctAnswerId]) {
          testTotalCount[correctAnswerId] = correctAnswerId
        }
      }

      self.setState({testTotalCount: testTotalCount})
    })
    
  }

  parentManufacturerField = ({...props}) => {
    let rowNumber = {...props}.rowIndex
    let link = "#"
    if (this.state.finalTestState[rowNumber].PriceListLink) {
      link = this.state.finalTestState[rowNumber].PriceListLink
    }
    let cellReturn = <div>
      <a rel="noopener noreferrer" target="_blank" href={link}>{this.state.finalTestState[rowNumber].ParentManufacturer}</a>
    </div>
    return cellReturn
  }
  titleField = ({...props}) => {
    let rowNumber = {...props}.rowIndex
    let link = "#"
    if (this.state.finalTestState[rowNumber].Asin) {
      link = ("https://www.amazon.com/dp/" + this.state.finalTestState[rowNumber].Asin)
    }
    let cellReturn = <div>
      <Popup
        trigger={<a rel="noopener noreferrer" target="_blank" href={link}>{this.state.finalTestState[rowNumber].Title}</a>}
        content={this.state.finalTestState[rowNumber].Title}
        wide
        size={"small"}
      />
    </div>
    return cellReturn
  }
  statusDropdown = ({...props}) => {
    let rowNumber = {...props}.rowIndex
    let rowInputId = "Status" + rowNumber
    let cellReturn = <div>
      <Popup 
        trigger={<div id={rowNumber}>{this.state.finalTestState[rowNumber].Status === undefined ? "Go" : this.state.finalTestState[rowNumber].Status}</div>} 
        on='click'
        open={this.state.popUpOpenInd[rowNumber]}
        onOpen={this.openPopUp}
      >
        <Popup.Header>Change Status</Popup.Header>
          <Popup.Content>
            <Dropdown id={rowInputId} selection
              placeholder="Go"
              value={this.state.finalTestState[rowNumber].Status === undefined ? "" : this.state.finalTestState[rowNumber].Status}
              onChange={this.handleChangeStatus}
              options={[{text: "Go", value: "Go"}, {text: "Couldn't Find in Price List", value: "Couldn't Find in Price List"}]}
            />
          </Popup.Content>
        </Popup>
      </div>
    return cellReturn
  }
  itemIdentifierInput = ({...props}) => {
    let rowNumber = {...props}.rowIndex
    let rowInputId = "itemidentifier" + rowNumber
    let isDisabled = false
    let backgroundColor = {}
    if (this.state.finalTestState[rowNumber].Status === "Couldn't Find in Price List") {
      isDisabled = true
      if (this.state.itemError[rowNumber] === true 
        || this.state.wholesaleError[rowNumber] === true 
        || this.state.asinError[rowNumber] === true
        || this.state.itemError[rowNumber] === false 
        || this.state.wholesaleError[rowNumber] === false 
        || this.state.asinError[rowNumber] === false) {
        backgroundColor = {background: '#00ff0044'}
      }
    } else if (this.state.itemError[rowNumber] === true 
        || this.state.wholesaleError[rowNumber] === true 
        || this.state.asinError[rowNumber] === true
        || this.state.itemError[rowNumber] === false 
        || this.state.wholesaleError[rowNumber] === false 
        || this.state.asinError[rowNumber] === false) {
      isDisabled = true
      backgroundColor = {background: '#00ff0044'}
    }
    var cellReturn = <div style={backgroundColor}>
        <Input id={rowInputId} placeholder="Item Identifier..." size="small" fluid error={this.state.itemError[rowNumber]} 
          disabled={isDisabled}
          value={this.state.finalTestState[rowNumber].itemidentifier === undefined ? "" : this.state.finalTestState[rowNumber].itemidentifier} 
          onChange={this.handleChange}/>
      </div>

    if (this.state.itemError[rowNumber] === true) {
      cellReturn = <div>
        <Popup trigger={<div><Input id={rowInputId} placeholder="Item Identifier..." size="small" fluid error={this.state.itemError[rowNumber]} 
          disabled={isDisabled}
          value={this.state.finalTestState[rowNumber].itemidentifier === undefined ? "" : this.state.finalTestState[rowNumber].itemidentifier} 
          onChange={this.handleChange}/></div>}
        content={this.state.finalTestAnswers[rowNumber].ItemIdentifier}
        />
      </div>
    }
    return cellReturn
  }
  manufacDescInput = ({...props}) => {
    let rowNumber = {...props}.rowIndex
    let rowInputId = "manufacturerdesc" + rowNumber
    let isDisabled = false
    let backgroundColor = {}
    if (this.state.finalTestState[rowNumber].Status === "Couldn't Find in Price List" 
        || this.state.itemError[rowNumber] === true 
        || this.state.wholesaleError[rowNumber] === true 
        || this.state.asinError[rowNumber] === true
        || this.state.itemError[rowNumber] === false 
        || this.state.wholesaleError[rowNumber] === false 
        || this.state.asinError[rowNumber] === false) {
      isDisabled = true
      backgroundColor = {background: '#00ff0044'}
    }
    var cellReturn = <div>
        <Input id={rowInputId} placeholder="Manufacturer Description..." size="small" fluid 
          disabled={isDisabled}
          value={this.state.finalTestState[rowNumber].manufacturerdesc === undefined ? "" : this.state.finalTestState[rowNumber].manufacturerdesc} 
          onChange={this.handleChange}/>
      </div>
    if (isDisabled) {
      cellReturn = <div>
        <Popup trigger={<div><Input id={rowInputId} placeholder="Manufacturer Description..." size="small" fluid 
          disabled={isDisabled}
          value={this.state.finalTestState[rowNumber].manufacturerdesc === undefined ? "" : this.state.finalTestState[rowNumber].manufacturerdesc} 
          onChange={this.handleChange}/></div>}
        content={this.state.finalTestAnswers[rowNumber].ManufacturerDescription}
        />
      </div>
    }

    return cellReturn
  }
  wholePriceInput = ({...props}) => {
    let rowNumber = {...props}.rowIndex
    let rowInputId = "wholesale" + rowNumber
    let isDisabled = false
    let backgroundColor = {}
    if (this.state.finalTestState[rowNumber].Status === "Couldn't Find in Price List") {
      isDisabled = true
      if (this.state.itemError[rowNumber] === true 
        || this.state.wholesaleError[rowNumber] === true 
        || this.state.asinError[rowNumber] === true
        || this.state.itemError[rowNumber] === false 
        || this.state.wholesaleError[rowNumber] === false 
        || this.state.asinError[rowNumber] === false) {
        backgroundColor = {background: '#00ff0044'}
      }
    } else if (this.state.itemError[rowNumber] === true 
        || this.state.wholesaleError[rowNumber] === true 
        || this.state.asinError[rowNumber] === true
        || this.state.itemError[rowNumber] === false 
        || this.state.wholesaleError[rowNumber] === false 
        || this.state.asinError[rowNumber] === false) {
      isDisabled = true
      backgroundColor = {background: '#00ff0044'}
    }
    var cellReturn = <div style={backgroundColor}>
        <Input id={rowInputId} placeholder="Wholesale Price..." size="small" fluid error={this.state.wholesaleError[rowNumber]}
          disabled={isDisabled}
          value={this.state.finalTestState[rowNumber].wholesale === undefined ? "" : this.state.finalTestState[rowNumber].wholesale} 
          onChange={this.handleChange}
          type={"number"}/>
      </div>

    if (this.state.wholesaleError[rowNumber] === true) {
      cellReturn = <div>
        <Popup trigger={<div><Input id={rowInputId} placeholder="Wholesale Price..." size="small" fluid error={this.state.wholesaleError[rowNumber]}
          disabled={isDisabled}
          value={this.state.finalTestState[rowNumber].wholesale === undefined ? "" : this.state.finalTestState[rowNumber].wholesale} 
          onChange={this.handleChange}
          type={"number"}/></div>}
        content={this.state.finalTestAnswers[rowNumber].WholesalePrice}
        />
      </div>
    }
    return cellReturn
  } 
  itemsPerAsinInput = ({...props}) => {
    let rowNumber = {...props}.rowIndex
    let rowInputId = "itemsperasin" + rowNumber
    let isDisabled = false
    let backgroundColor = {}
    if (this.state.finalTestState[rowNumber].Status === "Couldn't Find in Price List") {
      isDisabled = true
      if (this.state.itemError[rowNumber] === true 
        || this.state.wholesaleError[rowNumber] === true 
        || this.state.asinError[rowNumber] === true
        || this.state.itemError[rowNumber] === false 
        || this.state.wholesaleError[rowNumber] === false 
        || this.state.asinError[rowNumber] === false) {
        backgroundColor = {background: '#00ff0044'}
      }
    } else if (this.state.itemError[rowNumber] === true 
        || this.state.wholesaleError[rowNumber] === true 
        || this.state.asinError[rowNumber] === true
        || this.state.itemError[rowNumber] === false 
        || this.state.wholesaleError[rowNumber] === false 
        || this.state.asinError[rowNumber] === false) {
      isDisabled = true
      backgroundColor = {background: '#00ff0044'}
    }
    var cellReturn = <div style={backgroundColor}>
        <Input id={rowInputId} placeholder="Items Per Asin..." size="small" fluid error={this.state.asinError[rowNumber]}
          disabled={isDisabled}
          value={this.state.finalTestState[rowNumber].itemsperasin === undefined ? "" : this.state.finalTestState[rowNumber].itemsperasin} 
          onChange={this.handleChange}
          type={"number"}/>
      </div>
    if (this.state.asinError[rowNumber] === true) {
      cellReturn = <div>
        <Popup trigger={<div><Input id={rowInputId} placeholder="Items Per Asin..." size="small" fluid error={this.state.asinError[rowNumber]}
          disabled={isDisabled}
          value={this.state.finalTestState[rowNumber].itemsperasin === undefined ? "" : this.state.finalTestState[rowNumber].itemsperasin} 
          onChange={this.handleChange}
          type={"number"}/></div>}
        content={this.state.finalTestAnswers[rowNumber].ItemsPerAsin}
        />
      </div>
    }
    return cellReturn
  } 
  notesInput = ({...props}) => {
    let rowNumber = {...props}.rowIndex
    let rowInputId = "notes" + rowNumber
    let isDisabled = false
    let backgroundColor = {}
    if (this.state.finalTestState[rowNumber].Status === "Couldn't Find in Price List" 
        || this.state.itemError[rowNumber] === true 
        || this.state.wholesaleError[rowNumber] === true 
        || this.state.asinError[rowNumber] === true
        || this.state.itemError[rowNumber] === false 
        || this.state.wholesaleError[rowNumber] === false 
        || this.state.asinError[rowNumber] === false) {
      isDisabled = true
      backgroundColor = {background: '#00ff0044'}
    }
    var cellReturn = <div>
        <Input id={rowInputId} placeholder="Notes..." size="small" fluid 
          disabled={isDisabled}
          value={this.state.finalTestState[rowNumber].notes === undefined ? "" : this.state.finalTestState[rowNumber].notes} 
          onChange={this.handleChange}/>
      </div>
    if (isDisabled) {
      cellReturn = <div>
        <Popup trigger={<div><Input id={rowInputId} placeholder="Notes..." size="small" fluid 
          disabled={isDisabled}
          value={this.state.finalTestState[rowNumber].notes === undefined ? "" : this.state.finalTestState[rowNumber].notes} 
          onChange={this.handleChange}/></div>}
        content={this.state.finalTestAnswers[rowNumber].Notes}
        />
      </div>
    }
    return cellReturn
  }

  buttonRow = ({...props}) => {
    let rowNumber = {...props}.rowIndex
    let isDisabled = false
    if (this.state.itemError[rowNumber] === true 
        || this.state.wholesaleError[rowNumber] === true 
        || this.state.asinError[rowNumber] === true
        || this.state.itemError[rowNumber] === false 
        || this.state.wholesaleError[rowNumber] === false 
        || this.state.asinError[rowNumber] === false) {
      isDisabled = true
    }
    var cellReturn = <div>
        <Button disabled={isDisabled} id={{...props}.rowIndex} fluid size={'tiny'} onClick={this.openConfirm} >Submit</Button>
      </div>
    return cellReturn
  }

  changeRowClass({ index }) {
    if (index < 0) {
      return headerStyle
    }
    return defaultRowStyle
  }


  render() {
    const { finalTestState, progressBarInd, progressBarTot, incorrectEntries } = this.state
    var TableorLoading = <div>Loading test...</div>
    const totalIncorrect = incorrectEntries[0] + incorrectEntries[1] + incorrectEntries[2]
    var errorRow = <Grid columns='equal'>
      <Grid.Column>
        <Segment><span style={{fontSize: 15, fontWeight: '600'}}>Incorrect Count:</span> {totalIncorrect}</Segment>
      </Grid.Column>
      <Grid.Column>
        <Segment><span style={{fontSize: 15, fontWeight: '600'}}>Item Identifier Errors:</span> {incorrectEntries[0]}</Segment>
      </Grid.Column>
      <Grid.Column>
        <Segment><span style={{fontSize: 15, fontWeight: '600'}}>Wholesale Price Errors:</span> {incorrectEntries[1]}</Segment>
      </Grid.Column>
      <Grid.Column>
        <Segment><span style={{fontSize: 15, fontWeight: '600'}}>Items Per Asin Errors:</span> {incorrectEntries[2]}</Segment>
      </Grid.Column>
      
    </Grid>
    if (finalTestState.length > 0) {
      TableorLoading = <AutoSizer disableHeight>
          {({ width }) => (
            <Table
              ref="TestTwo"
              headerHeight={30}
              height={400}
              rowCount={103}
              rowGetter={({ index }) => finalTestState[index]}
              rowHeight={40}
              rowStyle={this.changeRowClass}
              width={width}
            >
            <Column
              label='Parent Manufacturer'
              dataKey='ParentManufacturer'
              width={220}
              cellRenderer={this.parentManufacturerField}
            />
            <Column
              width={300}
              label='Title'
              dataKey='Title'
              cellRenderer={this.titleField}
            />
            <Column
              width={75}
              label='Status'
              dataKey='Status'
              cellRenderer={this.statusDropdown}
            />
            <Column
              width={180}
              label='Item Identifier'
              dataKey='itemidentifier'
              cellRenderer={this.itemIdentifierInput}
            />
            <Column
              width={260}
              label='Manufacturer Description'
              dataKey='manufacturerdesc'
              cellRenderer={this.manufacDescInput}
            />
            <Column
              width={180}
              label='Wholesale Price'
              dataKey='wholesale'
              cellRenderer={this.wholePriceInput}
            />
            <Column
              width={180}
              label='Items Per Asin'
              dataKey='itemsperasin'
              cellRenderer={this.itemsPerAsinInput}
            />
            <Column
              width={170}
              label='Notes'
              dataKey='notes'
              cellRenderer={this.notesInput}
            />
            <Column 
              width={160} 
              label='Asin' 
              dataKey='Asin'
            /> 
            <Column
              width={110}
              dataKey='submit'
              cellRenderer={this.buttonRow}
            />
            </Table>
          )}
        </AutoSizer>;
    }

    var submitRow = 'Are you sure you want to submit your answers on row: ' + (this.state.submitRow + 1)
    var ConfirmBox = <Confirm
        open={this.state.openConfirmBox}
        content={submitRow}
        cancelButton='No!'
        confirmButton='Yes!'
        onCancel={this.handleCancel}
        onConfirm={this.submitRowAnswers}
      />

    var ProgressBar = <Transition visible={progressBarInd !== progressBarTot + 1} animation='fade down' duration={500}>
      <Progress value={progressBarInd} total={progressBarTot} size='tiny' color='blue' active />
      </Transition>

    return (
      <div>
        <div style={{position: 'absolute', width: '100%', top: '-1px'}}>{ProgressBar}</div>
        <div style={{position: 'absolute', top: '17%', left: '1%', width: '98%'}}>
        <Grid>
          <Grid.Column style={{marginRight: 130}}>
            <Segment style={{width: 200}}>
              <span style={{fontSize: 15, fontWeight: '600'}}>Allowed Incorrect:</span> 40
            </Segment>
          </Grid.Column>
          <Grid.Column>
            <Segment style={{width: 200}}>
              <span style={{fontSize: 15, fontWeight: '600'}}>Entry:</span> {incorrectEntries[3]} of 103
            </Segment>
          </Grid.Column>
        </Grid>
          
          
          {errorRow}
          {TableorLoading}
          {ConfirmBox}
        </div>

        <Modal
          defaultOpen
          header='Final Test'
          content='This test consists of 103 products. Correct answers will be highlighted in green. Incorrect answers will be highlighted in red. There is no need to correct wrong answers on this test. After all 103 products have been submitted you will receive a confirmation message and further instruction.'
          actions={[
            { key: 'done', content: 'Okay', positive: true },
          ]}
        />
      </div>
    );
  }
}

export default finalTest;



// WEBPACK FOOTER //
// ./src/pages/testpages/testfinal.js